import BaseModel from './BaseModel';
import MultiLanguageField from './MultiLanguageField';
import {parseLocale} from '../../utils/language.js';

export default class MultiLanguageDesignationModel extends BaseModel {
  constructor({
    id,
    number,
    designationFrBe = undefined,
    designationDeBe = undefined,
    designationNlBe = undefined,
    designationFrLu = undefined,
    designationDeLu = undefined,
    designationFrFr = undefined,
    designationDeDe = undefined,
    designationNlNl = undefined,
    designationEnGb = undefined,
    designationEnIn = undefined,
    designationMrIn = undefined,
    designationHiIn = undefined,
  }) {
    const designations = new MultiLanguageField({
      designationFrBe,
      designationDeBe,
      designationNlBe,
      designationFrLu,
      designationDeLu,
      designationFrFr,
      designationDeDe,
      designationNlNl,
      designationEnGb,
      designationEnIn,
      designationMrIn,
      designationHiIn,
    });
    super(id, number, designations.value);
    this.designations = designations.values;
  }

  /**
   * Designation in the requested locale, otherwise the connected user's designation.
   */
  designationForLocale(locale) {
    if (!locale || !this.designations) return this.designation;
    try {
      const localized = this.designations[parseLocale(locale).idApp];
      return localized || this.designation;
    } catch {
      return this.designation;
    }
  }

  static localeAttributeNames(prefix) {
    const names = [
      this.attributeUserLocale(prefix),
      this.attributeCompanyLocale(prefix),
      ...this.attributesAllCompanyLanguages(prefix),
    ].filter(Boolean);
    const known = new Set(this.allAttributes.map((att) => att.name));
    return [...new Set(names.filter((name) => known.has(name)))];
  }

  static get joinFilterColumns() {
    return [
      'no',
      this.attributeUserLocale('designation', true),
      this.attributeCompanyLocale('designation', true),
    ];
  }
  get joinFilterColumns() {
    return MultiLanguageDesignationModel.joinFilterColumns;
  }

  /**
   * Only join the necessary attributes for the designation
   */
  static get joinAttrsForDesignation() {
    const designationKeys = [
      'number',
      this.attributeUserLocale('designation', false),
      this.attributeCompanyLocale('designation', false),
    ];
    return designationKeys
      .map((key) => this.allAttributes.find((attr) => attr.name === key))
      .filter((attr) => attr !== undefined);
  }
}
